import Vue from 'vue';
import Component from 'vue-class-component';
import AddEmailToAllNewsLetterMutation from 'assets/graphql/mutations/AddEmailToAllNewsLetter.graphql';

@Component({
  props: {
    description: {
      required: true,
      type: String,
    },
    inputSize: {
      required: false,
      type: String,
    },
    disclaimer: {
      required: true,
      type: Boolean,
    },
  },
})
export default class NewsLetterSubscriptionComponent extends Vue {
  email = null;
  loading = false;
  showSuccessMessage = false;
  showNetworkErrorMessage = false;

  subscribe() {
    this.loading = true;

    this.$apollo
      .mutate({
        mutation: AddEmailToAllNewsLetterMutation,
        variables: {
          AddEmailToAllNewsLetterMutationInput: { email: this.email },
        },
      })
      .then(({ data }) => {
        if (data.add_email_to_all_newsletter.errors.length <= 0) {
          this.showSuccessMessage = true;
          this.showNetworkErrorMessage = false;
        } else {
          this.showSuccessMessage = false;
          this.showNetworkErrorMessage = true;
        }
      })
      .catch(() => {
        this.showSuccessMessage = false;
        this.showNetworkErrorMessage = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
